import { render, staticRenderFns } from "./FAQContentDetail.vue?vue&type=template&id=33619c54&scoped=true&"
import script from "./FAQContentDetail.vue?vue&type=script&lang=ts&"
export * from "./FAQContentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./FAQContentDetail.vue?vue&type=style&index=0&id=33619c54&lang=scss&scoped=true&"
import style1 from "./FAQContentDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33619c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VIcon,VRow})
